var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2V0H2.5C1.11997 0.00165306 0.00165306 1.11997 0 2.5V7.5C0.00165306 8.88003 1.11997 9.99835 2.5 10H5.5C6.88003 9.99835 7.99835 8.88003 8 7.5V3.5H6C5.17157 3.5 4.5 2.82843 4.5 2ZM5.5 2C5.5 2.27614 5.72386 2.5 6 2.5H7.983C7.94619 2.17534 7.80371 1.87177 7.5775 1.636L6.4355 0.4565C6.18568 0.203274 5.85426 0.0466872 5.5 0.0145V2ZM3 12H7.5C8.88003 11.9983 9.99835 10.88 10 9.5V4C10 3.72386 9.77614 3.5 9.5 3.5C9.22386 3.5 9 3.72386 9 4V9.5C9 10.3284 8.32843 11 7.5 11H3C2.72386 11 2.5 11.2239 2.5 11.5C2.5 11.7761 2.72386 12 3 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyShape);
export default ForwardRef;